import fclone from 'fclone';
export function cloneDeep(value) {
    return fclone(value);
}
//# sourceMappingURL=cloneDeep.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-utilities/lib/util/cloneDeep.js
// module id = 515
// module chunks = 146